import workspaceQuery from '../../../graphql/queries/product/AssemblyWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/AssemblyListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/AssemblyQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/AssemblyDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/AssemblyMutation.graphql';
import fragment from '../../../graphql/fragments/product/AssemblyFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { assemblyFormActionsForPermissions } from '../../../actions/product/AssemblyFormAction';
import { assemblyReservationFormActionsForPermissions } from '../../../actions/product/AssemblyReservationFormAction';
import { assemblyWorkspaceActionsForPermissions } from '../../../actions/product/AssemblyWorkspaceAction';

const Assembly: EntityType = {
  type: 'Assembly',
  title: 'Assembly',
  formTitle: 'Assembly',
  formUrl: '/Products/Assembly/Assembly/Details/',
  workspaceUrl: '/Products/Assembly/Assembly/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'ASSEMBLY',
  actions: [
    ...assemblyWorkspaceActionsForPermissions,
    ...assemblyFormActionsForPermissions,
    ...assemblyReservationFormActionsForPermissions,
  ],
};

export default Assembly;
